import React, { useState } from "react";
import { Alert } from "react-bootstrap";

const WarningAlert = ({ title, value, minValue, maxValue, showMin, showMax, otherValues }) => {
  const mainTitle = title
  switch (title) {
    case "engineSpeedRPM":
      if (minValue > value) {
        title = `Low Rotor Speed`;
      } else if (value > maxValue) {
        title = "High Rotor Speed";
      } else {
        title = `Rotor Speed`;
      }
      break;
    case "engineOilPressure":
      if (minValue > value) {
        title = `Low Coolant Oil Pressure`;
      } else if (value > maxValue) {
        title = "High Coolant Oil Pressure";
      } else {
        title = `Coolant Oil Pressure`;
      }
      break;
    case "engineCoolantTemp":
      if (minValue > value) {
        title = `Coolant Temperature`;
      } else if (value > maxValue) {
        title = "High Coolant Temperature";
      } else {
        title = `Coolant Temperature`;
      }
      break;
    case "oilTemp":
      if (minValue > value) {
        title = `Oil Temperature`;
      } else if (value > maxValue) {
        title = "High Oil Temperature";
      } else {
        title = `Oil Temperature`;
      }
      break;
    case "powerFactor":
      if (minValue > value) {
        title = `Low Power Factor`;
      } else if (value > maxValue) {
        title = "Power Factor";
      } else {
        title = `Power Factor`;
      }
      break;
    case "powerKW":
      if (minValue > value) {
        title = `Active Power`;
      } else if (value > maxValue) {
        title = "High Active Power";
      } else {
        title = `Active Power`;
      }
      break;
    case "kwh":
      if (minValue > value) {
        title = `Low Generated Power`;
      } else if (value > maxValue) {
        title = "High Generated Power";
      } else {
        title = `Generated Power`;
      }
      break;
    case "batteryVoltage":
      if (minValue > value) {
        title = `Low Battery Voltage`;
      } else if (value > maxValue) {
        title = "Battery Voltage";
      } else {
        title = `Battery Voltage`;
      }
      break;
    case "fuelLevel":
      if (minValue > value) {
        title = `Low Fuel Level`;
      } else if (value > maxValue) {
        title = "Fuel Level";
      } else {
        title = `Fuel Level`;
      }
      break;
    case "frequency":
      if (minValue > value) {
        title = `Low Frequency`;
      } else if (value > maxValue) {
        title = "High Frequency";
      } else {
        title = `Frequency`;
      }
      break;
    case "voltage":
      const {vY, vR, vB} = otherValues
      if (minValue > vY || minValue > vR || minValue > vB) {
        title = `Low AC Voltage`;
      } else if (vY > maxValue || vB > maxValue || vR > maxValue) {
        title = "High AC Voltage";
      } else {
        title = `AC Voltage`;
      }
      break;
    case "current":
      const {iY, iR, iB} = otherValues
      if (minValue > iY || minValue > iR || minValue > iB) {
        title = `Current`;
      } else if (iY > maxValue || iB > maxValue || iR > maxValue) {
        title = "High Current";
      } else {
        title = `Current`;
      }
      break;
    default:
      break;
  }
  const alertLogic = () => {
    if (mainTitle === "voltage" ) {
      const {vY, vR, vB} = otherValues
      if (minValue > vY || minValue > vR || minValue > vB) {
        return `warning`;
      } else if (vY > maxValue || vB > maxValue || vR > maxValue) {
        return `danger`;
      } else {
        return `success`;
      }
    } else if (mainTitle === "current") {
      const {iY, iR, iB} = otherValues
      if (iY > maxValue || iB > maxValue || iR > maxValue) {
        return `danger`;
      } else {
        return `success`;
      }
    }
    if (showMax && showMin) {
      if (value > minValue && value < maxValue) {
        return "success"
      }
      if (value > maxValue) {
        return "danger"
      }
      if (value < minValue) {
        return "warning"
      }
    }
    if (showMin) {
      if (value < minValue) {
        return "warning"
      } else if (value > minValue) {
        return "success"
      }
    }
    if (showMax) {
      if (value < maxValue) {
        return "success"
      } else if (value > maxValue) {
        return "danger"
      }
    }
   
    return "success"
  } 
  return (
    <div className="tw-flex tw-flex-row tw-justify-evenly tw-flex-wrap tw-mx-2 sm:tw-w-80 tw-w-5/6 tw-rounded-md">
      <Alert
        variant={alertLogic()}
        className="tw-text-center tw-text-lg tw-font-semibold sm:tw-w-80 tw-w-5/6"
      >
        {title}
        <div className="tw-flex tw-flex-row tw-mt-1 tw-justify-between tw-items-end">
          {showMin && <small className="tw-mx-4 tw-text-sm tw-text-gray-700">
            Min: {minValue}
          </small>}
          {showMax && <small className="tw-mx-4 tw-text-sm tw-text-gray-700">
            Max: {maxValue}
          </small>}
        </div>
      </Alert>
    </div>
  );
};

export default WarningAlert;
